import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "controls"
}
const _hoisted_5 = {
  key: 0,
  class: "divider"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "footer" }

import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import TextBase from '@/design-system/atoms/TextBase.vue'
import LayoutOverlay from '@/design-system/templates/LayoutOverlay.vue'
import { onMounted, onUnmounted, ref, toRefs, watch } from 'vue'

type Props = {
  title: string
  open?: boolean
  headerPadding?: string
  contentPadding?: string
  footerPadding?: string
  icon?: string
  hideDivider?: boolean
  hideControls?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalBase',
  props: {
    title: {},
    open: { type: Boolean, default: false },
    headerPadding: { default: '24px 24px 0' },
    contentPadding: { default: '16px 24px' },
    footerPadding: { default: '0 24px 24px' },
    icon: { default: undefined },
    hideDivider: { type: Boolean, default: false },
    hideControls: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "46d438e4": (_ctx.headerPadding),
  "126e33ce": (_ctx.contentPadding),
  "94cdb680": (_ctx.footerPadding)
}))

const props = __props

const { title } = toRefs(props)

const isOpen = ref(props.open)

const emit = __emit

onMounted(() => {
  window.addEventListener('keydown', handleKeydown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown)
})

const handleKeydown = (event: KeyboardEvent) => {
  if (!isOpen.value) return
  if (event.key === 'Escape') {
    closeModal()
  }
}

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue
  },
  { immediate: true }
)

const closeModal = () => {
  isOpen.value = false
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (isOpen.value)
    ? (_openBlock(), _createBlock(LayoutOverlay, {
        key: 0,
        onCloseOverlay: closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.icon)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
                      key: 0,
                      class: "icon"
                    }))
                  : _createCommentVNode("", true),
                (_unref(title))
                  ? (_openBlock(), _createBlock(TextBase, {
                      key: 1,
                      text: _unref(title),
                      type: "h4",
                      weight: "bold",
                      "overflow-tooltip": "",
                      overflow: "ellipsis"
                    }, null, 8, ["text"]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.hideControls)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "controls"),
                    _createVNode(ButtonText, {
                      class: "controls-close__button",
                      iconLeft: require('@/design-system/assets/icons/Icon-X-Small.svg'),
                      size: "extra-small-icon",
                      onOnClicked: closeModal
                    }, null, 8, ["iconLeft"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.hideDivider)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("main", _hoisted_6, [
              _renderSlot(_ctx.$slots, "content")
            ]),
            _createElementVNode("footer", _hoisted_7, [
              _renderSlot(_ctx.$slots, "footer")
            ])
          ])
        ]),
        _: 3
      }))
    : _createCommentVNode("", true)
}
}

})